import axios from 'axios';
import config from "../config";

// axios.defaults.baseURL = 'http://brightness.mynetgear.com:8081/hz';
// axios.defaults.baseURL = 'http://hz.richcyber.com:8081/hz';
// axios.defaults.baseURL = config.axiosBaseUrl;//正式
const { host } = window.location
axios.defaults.baseURL = host.includes('localhost') ? '/hz' : config.axiosBaseUrl;//开发

// axios.defaults.baseURL =  config.axiosBaseUrl;//开发


// axios.defaults.baseURL = 'http://gw.demo365.cc:18081/hz';//测试
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('viewToken');
  config.headers.token = token;
  config.headers.lang = !localStorage.getItem('lang') || localStorage.getItem('lang') == "zh" ? 'zh_CN' : 'en_US'
  return config;
}),
  (error) => {
    return Promise.error(error);
  };
axios.interceptors.response.use((response) => {
  const code = response.data.code;
  if (code === 4003 || code === 4005) {
    window.location.href = config.adminLogin;
    localStorage.removeItem('token');
    localStorage.removeItem('viewToken');
  }
  return response;
}),
  (error) => {
    return Promise.error(error);
  };
export default axios;
